import React, { CSSProperties, FC, PropsWithChildren, ReactNode } from 'react';
import { Form } from 'react-bootstrap';
import { FormFieldContext, FormFieldContextValue, useFormFieldContext } from './FormFieldContext';
import './FormField.scss';
import classNames from 'classnames';

export const FormField: FC<
  PropsWithChildren<{
    name: string;
    label?: string;
    hint?: string;
    className?: string;
    style?: CSSProperties;
    render?: (context: FormFieldContextValue) => ReactNode | ReactNode[];
  }>
> = ({ name, label, hint, render, className, children }) => {
  const contextValue = useFormFieldContext(name);

  return (
    <FormFieldContext.Provider value={contextValue}>
      <Form.Group className={classNames('FormField', className)} controlId={contextValue.controlId}>
        {label && <Form.Label className="label mb-1">{label}</Form.Label>}

        {render?.(contextValue)}

        {children}

        {hint && <Form.Text className="text-muted">{hint}</Form.Text>}

        {contextValue.error && (
          <Form.Control.Feedback type="invalid">{contextValue.error.message}</Form.Control.Feedback>
        )}
      </Form.Group>
    </FormFieldContext.Provider>
  );
};
